import React from 'react';
import { observer } from 'mobx-react-lite';
import { useSellerAction, useStores } from 'hooks';
import styled, { css } from 'styled-components';
import { breakpoints } from '../../../../shared/utils/styles';

export const SellerActions = observer(() => {
  const {
    BidStore: { auction },
  } = useStores();

  const { currentBid } = auction;

  const {
    okayToSell, doNotSell, sellerMessage, formattedReserve, isTake, hasNoReserve, hasMetReserve,
  } = useSellerAction(currentBid);

  return (
    <SellerActionsContainer isTake={isTake} okayToSell={okayToSell || hasNoReserve || hasMetReserve} doNotSell={doNotSell}>
      {sellerMessage ?? formattedReserve}
    </SellerActionsContainer>
  );
});

export default SellerActions;


const backgroundColor = (props) => {
  if (props.isTake) return '#FBCC08';
  if (props.okayToSell) return '#21BA45';
  return '#DB2828';
};

const color = (props) => {
  if (props.isTake) return '#000';
  if (props.okayToSell) return '#FFF';
  return '#FFF';
};

export const FlexRowContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const SellerActionsContainer = styled(FlexRowContainer)`
  ${({ okayToSell, isTake }) => css`
  grid-area: seller-actions;
  background-color: ${backgroundColor({ okayToSell, isTake })};
  color: ${color({ isTake, okayToSell })};
  font-size: 2em;
  @media (max-width: ${breakpoints.auctioneer.small}) {
    font-size: 1.5em;
  }
  font-weight: bold;
  padding: 5px;
  `};
`;
